import Banner from '../../components/Banner'
import ListaPratos from '../../components/ListaPratos'
import Loader from '../../components/Loader'
import ProfileHeader from '../../components/ProfileHeader'

export type Prato = {
  id: number
  foto: string
  preco: number
  nome: string
  descricao: string
  porcao: string
}

export interface Restaurante {
  id: number
  titulo: string
  destacado: boolean
  tipo: string
  avaliacao: number
  descricao: string
  capa: string
  cardapio: Prato[]
}

const Categories = () => {
  return (
    <>
      <ProfileHeader />
      <Banner />
      <ListaPratos />
    </>
  )

  return <Loader />
}

export default Categories
